
export interface Deploy {
	version: string,
	date: Date,				// fecha de despliegue o puesta en producción
	features: string[]		// listado de características asociados al despliegue
}

export const deploys: Deploy[] = [
	{
		version: '1.39.0',
		date: new Date( '2026-06-01T00:00:00.000-03:00' ),
		features: [
			'Se agregó el acceso a Humand en la página de inicio',
			'El sitio Normas y Procedimientos se cambió de ubicación a Bases de Conocimiento',
			'Se eliminó el acceso a Preguntas Frecuentes en "Mi Gestión RH".',
			'Se eliminó el acceso al sitio de Recursos Humanos desde la página de inicio.',
			'Se eliminaron de la página principal las noticias generales, beneficios, sitios de interés y pizarra. También se eliminaron de la sección "Mi Comunidad" los accesos a clasificados y cumpleaños.'
		]
	},
	{
		version: '1.38.2',
		date: new Date( '2026-01-29T00:00:00.000-03:00' ),
		features: [
			'Cambio de nombre y nuevos links en la mesa de ayuda Comunicación.',
			'Mejoras en la visualización de los logos de las redes del pie de página del sitio.',
			'Actualización en las tipografías de las salutaciones.'
		]
	},
	{
		version: '1.37.0',
		date: new Date( '2025-09-12T00:00:00.000-03:00' ),
		features: [
			'Mejoras en la seguridad de las imágenes y recursos del sitio.',
		]
	},
	{
		version: '1.36.0',
		date: new Date( '2025-09-05T00:00:00.000-03:00' ),
		features: [
			'Actualización en la visualización de la página de seguridad en la resolución celular.',
			'Mejoras en la herramienta de monitoreo del sitio.'
		]
	},
	{
		version: '1.35.0',
		date: new Date( '2025-08-22T00:00:00.000-03:00' ),
		features: [
			'Acceso a la actualización de la información para el recupero de cuenta desde la opción "Seguridad" del menú de usuario. Los nuevos formularios son: correo electrónico, teléfono celular y pregunta de seguridad.',
			'Nuevo diseño del pie de página del sitio.',
			'Actualización a la tipografía Fira Sans.'
		]
	},
	{
		version: '1.34.0',
		date: new Date( '2025-08-08T00:00:00.000-03:00' ),
		features: [
			'Actualización de accesos en la página de inicio.'
		]
	},
	{
		version: '1.33.0',
		date: new Date( '2025-07-30T00:00:00.000-03:00' ),
		features: [
			'Mejoras en la integración con Gmail.'
		]
	},
	{
		version: '1.32.0',
		date: new Date( '2025-07-03T00:00:00.000-03:00' ),
		features: [
			'Mejoras en el ingreso a Comunità.'
		]
	},
	{
		version: '1.31.0',
		date: new Date( '2025-04-22T00:00:00.000-03:00' ),
		features: [
			'Cambio de nombres Intituto Universitario y IUHIBA por Universidad.'
		]
	},
	{
		version: '1.30.0',
		date: new Date( '2025-03-07T00:00:00.000-03:00' ),
		features: [
			'Incorporación de los Aportes al Plan de Salud en Mi Perfil.',
			'Nuevas funcionalidades Reseña Profesional y Redes Sociales en Información Personal.',
			'En la página de inicio se cambió la ubicación de los beneficios.',
		]
	},
	{
		version: '1.29.0',
		date: new Date( '2024-09-27T00:00:00.000-03:00' ),
		features: [
			'Actualización en el acceso a Mi Gestión tanto desde la página de inicio como desde los accesos a las aplicaciones.',
			'Mejoras en la visualización de videos en la página de detalle de una noticia.',
			'Nuevo ícono para la aplicación Salesforce.',
		]
	},
	{
		version: '1.28.0',
		date: new Date( '2024-08-20T00:00:00.000-03:00' ),
		features: [
			'Nueva sección de Pizarra en la página de inicio.',
			'Mejoras en la visualización de los beneficios en la página de inicio.'
		]
	},
	{
		version: '1.27.0',
		date: new Date( '2024-04-05T00:00:00.000-03:00' ),
		features: [
			'En el cambio de clave se redujo el conjunto de caracteres especiales permitidos.',
			'Actualización de la página "Reporte de violencia laboral".'
		]
	},
	{
		version: '1.26.0',
		date: new Date( '2024-01-18T00:00:00.000-03:00' ),
		features: [
			'En el cambio de clave se agregó el requisito "Debe contener al menos un caracter especial".',
		]
	},
	{
		version: '1.25.0',
		date: new Date( '2023-12-27T00:00:00.000-03:00' ),
		features: [
			'Se agregaron sugerencias en el Menú Comedor de la página inicial.',
			'Rediseño de la página de seguridad.',
			'El modal de cambio de clave pasa a tener su propia página.'
		]
	},
	{
		version: '1.24.0',
		date: new Date( '2023-09-12T00:00:00.000-03:00' ),
		features: [
			'Rediseño de la sección Menú Comedor de la página de inicio.',
			'Integración con la nueva aplicación Menú Comedor.'
		]
	},
	{
		version: '1.23.0',
		date: new Date( '2023-07-04T00:00:00.000-03:00' ),
		features: [
			'En la sección "Cápita de Pacientes" se incorporó la estadística "Total de pacientes por rango etario". Además se agregó una barra de herramientas que permite seleccionar la representación de la información: gráfico de barras o de torta.',
			'En la sección de "Información Personal" del usuario se incorporaron los datos de contacto',
			'Integración con Google Analytics 4',
			'A partir de esta versión es posible guardar una URL del sitio y ser luego redireccionado a esa página sin importar si el usuario ya ingresó Comunità. Esta funcionalidad permite poder utilizar los favoritos del navegador con las páginas de Comunità.',
			'En la página de "Cumpleaños" se solucionó un problema relacionado con la última fecha de envío de salutación',
			'En la página principal se eliminó el acceso a la "Revista Entre Nosotros" como parte de un proceso de reestructuración de la sección'
		]
	},
	{
		version: '1.22.0',
		date: new Date( '2023-05-30T00:00:00.000-03:00' ),
		features: [
			'Nuevo sitio de interés "Donación de órganos y tejidos"'
		]
	},
	{
		version: '1.21.0',
		date: new Date( '2023-03-31T00:00:00.000-03:00' ),
		features: [
			'Nueva sección de cumpleaños accesible desde la página de inicio',
			'Actualización en la página de inicio de los Sitios de Interés, se agrega el sitio "CEPI"',
			'Nuevas categorias de beneficios: "productos" y "servicios"',
			'Mejoras en la seguridad del sitio'
		]
	},
	{
		version: '1.20.1',
		date: new Date( '2023-01-18T00:00:00.000-03:00' ),
		features: [
			'Incorporación de la sección "Mi gestión" en la página de inicio de la versión mobile',
			'Ajustes visuales en la versión mobile en la página "Información personal" y en la sección "Pensando en vos - Red de beneficios" de la página de inicio',
			'Mejora en el tratamiento del apellido del usuario',
			'Mejora en el circuito de actualización de la página "8700 Emergencias"'
		]
	},
	{
		version: '1.19.1',
		date: new Date( '2022-11-18T00:00:00.000-03:00' ),
		features: [
			'En el menú lateral de la versión mobile se solucionó el problema de acceso a las aplicaciones',
			'Mejoras en la navegación de las páginas de "Recursos Institucionales" e "Información Médica": se pueden utilizar los botones de historial del navegador (atrás/adelante) para cambiar de carpeta',
			'Mejoras visuales en la página de aplicaciones para la versión mobile'
		]
	},
	{
		version: '1.19.0',
		date: new Date( '2022-11-16T00:00:00.000-03:00' ),
		features: [
			'Incorporación de un menú lateral en la versión mobile del sitio, accesible desde el ícono de la "hamburguesa" que aparece a la izquierda del logo de Comunità en la parte superior del sitio',
			'En las páginas de "Recursos Institucionales" e "Información Médica" es posible agregar como favorito del navegador una carpeta',
			'Mejoras en la foto de perfil del usuario',
			'Actualización de la plataforma interna del sitio'
		]
	},
	{
		version: '1.18.0',
		date: new Date( '2022-09-20T00:00:00.000-03:00' ),
		features: [
			'Incorporación de la mesa de ayuda Gestión de Implantes',
			'Nuevo sitio de interés "Aprender Salud"'
		]
	},
	{
		version: '1.17.0',
		date: new Date( '2022-09-01T00:00:00.000-03:00' ),
		features: [
			'Incorporación de la mesa de ayuda Gerencia Comercial',
			'Acceso al reporte "Disponibilidad de camas del día" desde la página principal',
			'Acceso a los recursos relacionados con "Información médica" también desde la página principal'
		]
	},
	{
		version: '1.16.2',
		date: new Date( '2022-07-07T00:00:00.000-03:00' ),
		features: [
			'Acceso a cambio la clave desde la opción "Seguridad" del menú de usuario',
			'Aviso de vencimiento de clave',
			'Envío de mensajes a la cápita en la opción "Cápita de Mensajes" del menú de usuario',
			'Cambio de título en mesa de ayuda de Ing. de Planta'
		]
	},
	{
		version: '1.15.1',
		date: new Date( '2022-01-19T00:00:00.000-03:00' ),
		features: [
			'Acceso a "Recursos Institucionales" desde la página principal',
			'Creación del "Reporte de Faltantes" accesible también desde la página principal',
			'Mejoras en la visualizacíon de noticias',
			'Actualización en el proceso interno de creación de sesión'
		]
	},
	{
		version: '1.14.0',
		date: new Date( '2021-12-21T00:00:00.000-03:00' ),
		features: [
			'Incoporación de la Cápita de Pacientes en el menú del usuario',
			'Actualización en la página de inicio de los Sitios de Interés, se agrega el sitio "Responsabilidad Social"'
		]
	},
	{
		version: '1.13.3',
		date: new Date( '2021-10-20T00:00:00.000-03:00' ),
		features: [
			'Actualización en la página de inicio de los Sitios de Interés, se agrega el sitio "Valoras Banco de Tiempo"',
			'Mejoras en el menú del usuario y en la visualización de la Información Personal y los Comprobantes de Tesorería'
		]
	},
	{
		version: '1.13.2',
		date: new Date( '2021-08-27T00:00:00.000-03:00' ),
		features: [
			'Actualización en la página de inicio de los Sitios de Interés, se agrega el sitio "Acreditación Hospitalaria"'
		]
	},
	{
		version: '1.13.1',
		date: new Date( '2021-07-28T00:00:00.000-03:00' ),
		features: [
			'Mejoras en los Comprobantes de Tesorería, se incorpora la búsqueda automática al ingresar y la previsualización de los archivos PDF.',
		]
	},
	{
		version: '1.13.0',
		date: new Date( '2021-07-01T00:00:00.000-03:00' ),
		features: [
			'Incorporación de los Comprobantes de Tesorería en Mi Perfil.',
			'Personalización de los correos electrónicos desde la sección Correos Electrónicos accesible desde \'VER TODOS\' en el panel izquierdo de la página de inicio',
			'Mejoras visuales en la página de inicio'
		]
	},
	{
		version: '1.12.0',
		date: new Date( '2021-03-30T00:00:00.000-03:00' ),
		features: [
			'Incorporación del formulario de Sugerencias en el menú de opciones del usuario',
			'Nueva opción para habilitar o deshabilitar formulario de Sugerencias al "Restaurar versión anterior"',
			'Acceso a 3 aplicaciones en la sección Aplicaciones'
		]
	},
	{
		version: '1.11.0',
		date: new Date( '2021-03-11T00:00:00.000-03:00' ),
		features: [
			'Incorporación de las salutaciones',
			'Solución al error de visualización de Sitios de Interés en el navegador Safari',
			'Mejoras en la visualización del detalle de un beneficio'
		]
	},
	{
		version: '1.10.0',
		date: new Date( '2021-01-13T00:00:00.000-03:00' ),
		features: [
			'Incorporación en la página principal de Pensando en Vos - Red de Beneficios',
			'Página de detalle de un beneficio en particular',
			'Página Acerca de Comunità con las características principales desarrolladas en cada versión',
			'Página con Información Personal del usuario'
		]
	},
	{
		version: '1.9.0',
		date: new Date( '2020-11-19T00:00:00.000-03:00' ),
		features: [
			'Incorporación del Buscador de Personas e Internos en Mi Comunidad',
			'Integración con la nueva interfaz de acceso a los servicios de RRHH',
			'Actualización de link en Mesa de Ayuda de Ingeniería de Planta',
			'Acceso a 15 aplicaciones en la seccion Aplicaciones'
		]
	},
	{
		version: '1.8.0',
		date: new Date( '2020-10-19T00:00:00.000-03:00' ),
		features: [
			'Inclusión de la encuesta de satisfacción al restaurar versión anterior',
			'Acceso a los Cajeros de Autogestión resuelto',
			'Incorporación de la categoría al banner de noticias destacadas',
			'Acceso a 15 aplicaciones en la seccion Aplicaciones'
		]
	},
	{
		version: '1.7.0',
		date: new Date( '2020-10-02T00:00:00.000-03:00' ),
		features: [
			'Personalización de las aplicaciones favoritas desde la sección Aplicaciones',
			'Inclusión de PAMT como Sitio de Interés'
		]
	},
	{
		version: '1.6.0',
		date: new Date( '2020-09-08T00:00:00.000-03:00' ),
		features: [
			'Integración con Google Analytics',
			'Nuevo ícono para la aplicación Historia Clínica',
			'Incorporación de la mesa de ayuda Nuevo Equipamiento',
			'Acceso a 6 aplicaciones en la seccion Aplicaciones',
		]
	},
	{
		version: '1.5.0',
		date: new Date( '2020-08-14T00:00:00.000-03:00' ),
		features: [
			'Ingreso a Campus HI no requiere login',
			'Ingreso a la Historia Clínica por fuera de la red del HI',
			'Inclusión del Portal Personal de Salud como Sitio de Interés',
			'Acceso a 21 aplicaciones en la seccion Aplicaciones'
		]
	},
	{
		version: '1.4.0',
		date: new Date( '2020-07-07T00:00:00.000-03:00' ),
		features: [
			'Corrección de link y texto en mesa de ayuda de Ingeniería de Planta',
			'Cambio de tamaño en la versión mobile de los sitios de interés'
		]
	},
	{
		version: '1.3.0',
		date: new Date( '2020-07-02T00:00:00.000-03:00' ),
		features: [
			'Página principal conteniendo: noticias destacadas, noticias generales, Mi Comunidad, Sitios de Interés y Revista Entre Nosotros',
			'Panel izquierdo de página principal con acceso a: Recursos Humanos, Mis Cursos, Hospital Italiano sitio institucional, Instituto Universitario Hospital Italiano, email institucional y cuentas genéricas, aplicaciones favoritas, bases de conocimiento y reportes',
			'Panel derecho de página principal con acceso a: Mi Gestion RH, menú del día Hospital Central y pizarra',
			'Mesas de ayuda: Sistemas Informáticos, Empadronamiento, Recursos Humanos, Ingeniería de Planta y Noticias',
			'Página detalle de una noticia destacada o general',
			'Acceso a 18 aplicaciones en la sección Aplicaciones',
			'Restaurar versión anterior'
		]
	}
]